













































































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { ITicket } from "@/types/ticket";

@Component({
  components: {},
})
export default class extends Vue {
  @Action("ticket/salesGet")
  public get!: (id: number) => Promise<void>;

  @Getter("ticket/single")
  public ticket!: ITicket;

  @Action("ticket/salesDelete")
  public delete!: (id: number) => Promise<boolean>;

  @Mutation("partner/clear")
  public clear!: () => void;

  public ticket_id = 0;
  public member_id = 0;
  public dialog = false;

  private async created() {
    this.ticket_id = Number(this.$route.params.ticket_id);
    this.member_id = Number(this.$route.params.member_id);

    this.clear();
    await Promise.all([this.get(this.ticket_id)]);
  }

  private async destroy() {
    const result = await this.delete(this.ticket_id);
    if (result) {
      this.$router.go(-1);
    }
    // this.$router.push({ name: "SalesTicketList" });
  }

  private get editPage() {
    if (this.member_id) {
      return {
        name: "SalesMemberTicketEdit",
        params: { member_id: this.member_id, ticket_id: this.ticket_id },
      };
    }
    return {
      name: "SalesTicketEdit",
      params: { ticket_id: this.ticket_id },
    };
  }
}
